// Mixing jQuery and Node.js code in the same file? Yes please!

/*$(function(){

    $('.logField').append('<br>Comando recibido: <span>' + 'Hola comando' + '</span>');    

});*/

import { platformHandler } from "../platforms/PlatformHandler";
import { requestPostSail } from "../utils/requester";

export class PluginHandler {
  constructor() {}

  messageFromWebPlugin(
    jsonMsg,
    webView,
    currentData,
    isExhibitor,
    isAutoviewer = false
  ) {
    console.log("Llega el comnado para el frame dee ", jsonMsg);
    var isHotPlugin = jsonMsg.nameIframe.indexOf("HotPlugin") != -1;
    var hotPluginInfo = platformHandler.getState().containers.appReducer
      .hotPluginInfo;

    switch (jsonMsg.cmd) {
      case "initInfo": //ojo que hay uno de estos mismos en slideconnector general, falta unificarlo
        let resp = {
          cmd: "initInfoCB",
          source: "flipwit",
          title: currentData.titleActivity,
          info: currentData.infoActivity,
          count: currentData.usersCount,
          session: platformHandler.getUrlForUser(),
          uidSelf: platformHandler.getFullUserUid(),
          configSession: platformHandler.getConfigPPT(),
          demoData: platformHandler.getDemoData(),
          exhibitor: currentData.idUserPresentation
        };

        //Si el iFrame es de un hotPlugin y tiene la información del hotPlugin entonces la pasa
        if (isHotPlugin) {
          if (
            hotPluginInfo.pluginInfo !== undefined &&
            hotPluginInfo.pluginInfo.titleToglea
          ) {
            resp.title = hotPluginInfo.pluginInfo.titleToglea;
          }
          //Pero si no entonces mira si el plugin cargado quiere cargar información de la diapositiva
          //actual y no del hotPlugin, la informacion del hotplugin esta en el nodo currendData del firebase
          //pero hay hotPlugin, por ejemplo el de ver las respuestas actuales o las preguntas, que lo que
          //quieren no es ver la info de ese hotPlugin sino de la actividad actual (diapositiva actual),
          //estos envian el parametro para indicar que quieren es informacion de la diapositiva
          else {
            if (
              jsonMsg.attendCurrentActivity === false ||
              jsonMsg.attendCurrentActivity === undefined
            ) {
              resp.title = "";
            }
          }

          if (
            hotPluginInfo.pluginInfo !== undefined &&
            hotPluginInfo.pluginInfo.infoToglea
          ) {
            resp.info = hotPluginInfo.pluginInfo.infoToglea;
          } else {
            if (
              jsonMsg.attendCurrentActivity === false ||
              jsonMsg.attendCurrentActivity === undefined
            ) {
              resp.info = "";
            }
          }
        }

        console.log("info de init " + resp);
        webView.sendMessage(JSON.stringify(resp));
        break;

      case "initInfoHotPlugin": //ojo que hay uno de estos mismos en slideconnector general, falta unificarlo
        resp = {
          cmd: "initInfoHotPluginCB",
          source: "flipwit"
        };
        console.log("info de init " + resp);
        webView.sendMessage(JSON.stringify(resp));
        break;

      /*
        Cuando llega un mensaje de un hotplugin, por ejemplo una pregunta hecha por la audiencia
       */
      case "msgHotPlugin":
        //El hotplugin de pregunta fue el primero desarrollado y para no dañar cosas se hace esta exclusion
        //ya que los hotplugin nuevos no tienen un nodo nuevo en firebase sino que funcionan sobre el mismo
        //currentData
        if (jsonMsg.activityForHotPlugin === "5bc75125abfe121a3c2fbdac") {
          platformHandler.sendHotPluginNewInfo(
            this.OnHotPluginNewInfo.bind(this, webView),
            jsonMsg.key,
            jsonMsg.info,
            jsonMsg.activityForHotPlugin,
            currentData.idUserPresentation
          );
        } else {
          //No tiene un numero de diapositiva sino que se coloca "hot" para que todos puedan saber
          //que el mensaje es de un hot plugin
          //Como es hot en vez de tomar el id de la actividad toma el id del plugin como id
          platformHandler.sendMsgActivity(
            "hot",
            jsonMsg.info,
            jsonMsg.activityForHotPlugin,
            currentData.idUserPresentation
          );
        }
        break;

      case "listenHotPluginInfo":
        platformHandler.setListenerHotPluginInfo(
          this.OnHotPlugin.bind(this, webView),
          jsonMsg.callbackTypes,
          jsonMsg.activityForHotPlugin,
          currentData.idUserPresentation
        );
        break;

      case "listenActMsgs":
        if (isHotPlugin) {
          console.log("TTT tiene ", isExhibitor, currentData, hotPluginInfo);

          if (
            jsonMsg.attendCurrentActivity === false ||
            jsonMsg.attendCurrentActivity === undefined
          ) {
            platformHandler.setListenerActMsgs(
              this.OnActMsgs.bind(this, webView),
              hotPluginInfo.pluginInfo ? hotPluginInfo.pluginInfo.idToglea : "",
              isExhibitor ? null : currentData.idUserPresentation
            );
          } else {
            console.log("TTT 2", currentData.idToglea);
            platformHandler.setListenerActMsgs(
              this.OnActMsgs.bind(this, webView),
              currentData.idToglea + this.getSuffixActivity(currentData),
              isExhibitor ? null : currentData.idUserPresentation
            );
          }
        } else {
          console.log("currentData", currentData);
          platformHandler.setListenerActMsgs(
            this.OnActMsgs.bind(this, webView),
            currentData.idToglea + this.getSuffixActivity(currentData),
            isExhibitor ? null : currentData.idUserPresentation
          );
        }
        break;

      case "addMsgAct":
      case "msgAct":
        if (isHotPlugin) {
          console.log("Enviar mensaje con ", hotPluginInfo.pluginInfo);
          platformHandler.sendMsgActivity(
            hotPluginInfo.pluginInfo.slideIndex,
            jsonMsg.info,
            hotPluginInfo.pluginInfo.idToglea,
            currentData.idUserPresentation,
            hotPluginInfo.pluginInfo.infoToglea.allowMultipleMessages,
            jsonMsg.cmd === "addMsgAct"
          );
        } else {
          console.log("CURRENT", currentData);
          console.log(
            "Enviar mensaje msgAct con ",
            currentData.indexSlide,
            jsonMsg.info,
            currentData.idToglea,
            currentData.idUserPresentation
          );

          var allowMultipleMessages = currentData.infoActivity
            ? currentData.infoActivity.allowMultipleMessages
            : false;
          if (allowMultipleMessages === undefined)
            allowMultipleMessages = false;

          platformHandler.sendMsgActivity(
            currentData.indexSlide,
            jsonMsg.info,
            currentData.idToglea + this.getSuffixActivity(currentData),
            currentData.idUserPresentation,
            allowMultipleMessages,
            jsonMsg.cmd === "addMsgAct"
          );
        }
        break;

      case "lastMsgActivity":
        console.log(
          "TTT De donde lo pide ->",
          `HotPlugin ${isHotPlugin}`,
          jsonMsg,
          webView,
          currentData,
          hotPluginInfo
        );
        if (isAutoviewer) {
          var obj = {
            val: function() {
              return null;
            }
          };

          this.OnMsgActivityUser(webView, obj);
        } else {
          if (isHotPlugin) {
            if (
              jsonMsg.attendCurrentActivity === false ||
              jsonMsg.attendCurrentActivity === undefined
            ) {
              platformHandler.getMsgActivityUser(
                this.OnMsgActivityUser.bind(this, webView),
                hotPluginInfo.pluginInfo
                  ? hotPluginInfo.pluginInfo.idToglea
                  : "",
                currentData.idUserPresentation
              );
            } else {
              platformHandler.getMsgActivityUser(
                this.OnMsgActivityUser.bind(this, webView),
                currentData.idToglea,
                currentData.idUserPresentation
              );
            }
          } else {
            platformHandler.getMsgActivityUser(
              this.OnMsgActivityUser.bind(this, webView),
              currentData.idToglea + this.getSuffixActivity(currentData),
              currentData.idUserPresentation
            );
          }
        }
        break;

      case "createAct":
        this.createActivity(jsonMsg, webView);
        break;

      case "insertAct":
        this.insertActivity(jsonMsg, webView, currentData.slideName);
        break;

      case "savedActs":
        this.getSavedActsPackage(jsonMsg, webView);
        break;

      case "deleteAct":
        this.deleteActivity(jsonMsg, webView);
        break;

      case "updateAct":
        this.updateActivity(jsonMsg, webView);
        break;

      case "getExhibitorMsgs":
        if (isAutoviewer) {
          var obj = {
            val: function() {
              return null;
            }
          };

          this.OnExhibitorMsgs(webView, obj);
        } else {
          if (isHotPlugin) {
            platformHandler.getExhibitorMsgs(
              this.OnExhibitorMsgs.bind(this, webView),
              hotPluginInfo.pluginInfo.idToglea,
              currentData.idUserPresentation
            );
          } else {
            platformHandler.getExhibitorMsgs(
              this.OnExhibitorMsgs.bind(this, webView),
              currentData.idToglea + this.getSuffixActivity(currentData),
              currentData.idUserPresentation
            );
          }
        }
        break;

      case "listenUsersConnections":
        platformHandler.setListenerUsersMsgs(this.OnUsers.bind(this, webView));
        break;

      case "funnelAutoviewer":
        this.getDataFunnel(webView);
        break;

      case "seeHotPlugin":
        const {
          pluginName,
          pluginView,
          userView,
          showViewerInExhibitor
        } = jsonMsg;
        platformHandler.activateHotPlugin({
          activated: true,
          pluginName,
          pluginView,
          userView,
          showViewerInExhibitor
        });
        break;

      /**
       * Para llamar una funcion especifica hacia el backEnd
       */
      case "callCustomSailsFunction":
        console.log("Llega el mensaje de call custom");
        //currentData.idToglea + this.getSuffixActivity( currentData ) -> id de la actividad actual en el firebase
        platformHandler.callCustomSailsFunction(
          this.OnCustomSailsFunction.bind(this, webView),
          jsonMsg,
          currentData.idToglea + this.getSuffixActivity(currentData)
        );
        break;

      case "deleteMsgHotPlugin":
        platformHandler.deleteMsgHotPlugin(
          jsonMsg.activityForHotPlugin,
          jsonMsg.key,
          jsonMsg.innerKey,
          currentData.idUserPresentation
        );
        break;

      default:
        console.log("not supported " + jsonMsg.cmd);
        break;
    }
  }

  getSuffixActivity = currentData => {
    return "-" + currentData.indexSlide;
  };

  getDataFunnel = webView => {
    var payload = {
      pptName: platformHandler.getPPTName(),
      user: platformHandler.getUser()
    };

    requestPostSail(
      process.env.REACT_APP_URL_SERVICES + "AutoviewerRep/getFunnel",
      payload,
      this.callbackFunnel.bind(this, webView)
    );
  };

  callbackFunnel(webView, data) {
    var resp = {
      source: "flipwit",
      cmd: "funnelAutoviewer",
      data
    };

    webView.sendMessage(JSON.stringify(resp));
  }

  deleteActivity(jsonMsg, webView) {
    var payload = {
      user: platformHandler.getUser(),
      idAct: jsonMsg.id
    };

    requestPostSail(
      process.env.REACT_APP_URL_SERVICES + "activity/deleteAct",
      payload,
      this.callbackDelete.bind(this, webView)
    );
  }

  callbackDelete(webView, data) {
    var resp = {
      source: "flipwit",
      cmd: "deleteActCB",
      success: true
    };

    webView.sendMessage(JSON.stringify(resp));
  }

  getSavedActsPackage(jsonMsg, webView) {
    var payload = {
      user: platformHandler.getUser(),
      pack: jsonMsg.package,
      idAct: jsonMsg.idAct
    };

    requestPostSail(
      process.env.REACT_APP_URL_SERVICES + "activity/getSavedActs",
      payload,
      this.callbackSavedActs.bind(this, webView)
    );
  }

  callbackSavedActs(webView, data) {
    var resp = {
      source: "flipwit",
      cmd: "savedActsCB",
      success: true,
      data: data
    };

    webView.sendMessage(JSON.stringify(resp));
  }

  insertActivity(jsonMsg, webView, pptName) {
    platformHandler.insertActivity(
      jsonMsg.id,
      jsonMsg.urlImg,
      pptName,
      jsonMsg.comment,
      webView
    );
  }

  updateActivity(jsonMsg, webView) {
    var payload = {
      id: jsonMsg.id,
      idUser: platformHandler.getUser(),
      title: jsonMsg.title,
      info: jsonMsg.info,
      urlImg: jsonMsg.urlImg
    };

    requestPostSail(
      process.env.REACT_APP_URL_SERVICES + "activity/updateActivity",
      payload,
      this.callbackUpdate.bind(this, webView)
    );
  }

  callbackUpdate(webView, data) {
    var resp = {
      source: "flipwit",
      cmd: "updateActCB",
      success: true
    };

    webView.sendMessage(JSON.stringify(resp));
  }

  createActivity(jsonMsg, webView) {
    var payload = {
      idActivity: jsonMsg.id,
      idUser: platformHandler.getUser(),
      title: jsonMsg.title,
      info: jsonMsg.info,
      package: jsonMsg.package
    };

    console.log("Crear con ", jsonMsg);

    requestPostSail(
      process.env.REACT_APP_URL_SERVICES + "activity/createActivity",
      payload,
      this.callbackCreate.bind(this, webView)
    );
  }

  callbackCreate(webView, data) {
    var resp = {
      source: "flipwit",
      cmd: "createActCB",
      success: true,
      id: "",
      title: "",
      urlImg: ""
    };

    if (data.id) {
      resp.id = data.id;
      resp.title = data.title;
      resp.urlImg = data.urlImg;
    } else {
      resp.success = false;
    }
    webView.sendMessage(JSON.stringify(resp));
  }

  OnActMsgs(webView, msgs) {
    console.log("[PluginHandler] ", msgs);
    var temp = {
      source: "flipwit",
      cmd: "listenActMsgsCB",
      //info: msgs.val()
      info: msgs
    };
    webView.sendMessage(JSON.stringify(temp));
  }

  OnExhibitorMsgs(webView, msgs) {
    var temp = {
      source: "flipwit",
      cmd: "onExhibitorMsgsCB",
      info: msgs.val()
    };
    webView.sendMessage(JSON.stringify(temp));
  }

  OnMsgActivityUser(webView, msgs) {
    console.log("llegan OnMsgActivityUser ", msgs.val());

    var temp = {
      source: "flipwit",
      cmd: "lastMsgActivityCB",
      info: msgs.val()
    };
    webView.sendMessage(JSON.stringify(temp));
  }

  OnUsers(webView, users) {
    var temp = {
      source: "flipwit",
      cmd: "listenUsersConnectionsCB",
      users: users
    };
    webView.sendMessage(JSON.stringify(temp));
  }

  OnHotPlugin(webView, infoHotPlugin) {
    console.log("ENVIAR HOT ", infoHotPlugin, webView);
    var temp = {
      source: "flipwit",
      cmd: "listenHotPluginCB",
      typeData: infoHotPlugin.typeData,
      info: infoHotPlugin.info
    };
    webView.sendMessage(JSON.stringify(temp));
  }

  OnHotPluginNewInfo(webView, msgs) {
    console.log("[PluginHandler] " + msgs);
    var temp = {
      source: "flipwit",
      cmd: "listenHotPluginNewInfoCB",
      //info: msgs.val()
      typeData: msgs.typeData,
      info: msgs.info
    };
    webView.sendMessage(JSON.stringify(temp));
  }

  OnCustomSailsFunction(webView, msgs) {
    console.log("[PluginHandler] Custom", msgs);
    var temp = {
      source: "flipwit",
      cmd: "listenCustomSailsFunction",
      //info: msgs.val()
      typeData: msgs.typeData,
      info: msgs.info
    };
    webView.sendMessage(JSON.stringify(temp));
  }
}



// WEBPACK FOOTER //
// ./src/containers/utils/pluginHandler.js